module.exports = __webpack_public_path__ + "static/img/zhuanli05.38a44e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/service/intellectualProperty/zhuanli05.png
// module id = 3x5V
// module chunks = 1